import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DealsPipeLineService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/dealsPipeLine";

  newDealsPipeLine(pipeLIne: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, pipeLIne)
  }

  getDealsPipeLineStagesById(pipelineId: number): Observable<any> {
    return this.http.get(`${this.url}/status/${pipelineId}`);
  }

  getDealsPipeLineStagesByIdAndActive(pipelineId: number): Observable<any> {
    return this.http.get(`${this.url}/status/active/${pipelineId}`);
  }

  getDealsPipeLineById(pipelineId: number): Observable<Object> {
    return this.http.get(`${this.url}/${pipelineId}`);
  }

  getDealsPipeLineByIdAndActive(pipelineId: number): Observable<Object> {
    return this.http.get(`${this.url}/active/${pipelineId}`);
  }

  getDealsPipeLine(Page: number, size: number, sort, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  getAllDealsPipeLineDropDown(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?type=${type}`);
  }

  getDealsPipeLineSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }

  getDealsPipeLineStageById(pipelineId: number): Observable<Object> {
    return this.http.get(`${this.url}/status/${pipelineId}`);
  }

  isLoading = new Subject<boolean>();

  show() {
    this.isLoading.next(true);

  }

  deletePipelineById(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

}
